import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from 'blocks/TextBlock'

import { LabelWithBorderLeft } from 'atoms/Label/Templates'
import {
  TextBoxMaxLine2Headline1,
  TextBoxMaxLine4Body3,
} from 'atoms/TextBox/Templates'
import { TextBlock, TextBlockRowGap } from 'blocks/TextBlock'

export interface ITextBlockBannerHeadline1Props extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
  purchaseTitle?: string
}

export const TextBlockBannerHeadline1 = ({
  title,
  description,
  width = 100,
  rowGap = TextBlockRowGap.INDENT_10,
  purchaseTitle,
  ...rest
}: ITextBlockBannerHeadline1Props): JSX.Element => {
  return (
    <TextBlock width={width} rowGap={rowGap} {...rest}>
      {purchaseTitle && <LabelWithBorderLeft title={purchaseTitle} />}
      <TextBoxMaxLine2Headline1 title={title} />
      <TextBoxMaxLine4Body3 preWrap>{description}</TextBoxMaxLine4Body3>
    </TextBlock>
  )
}
